import type { Match, Observation } from '@/types';

/** Indexe les matchs par `cle` et `idmatch_football` pour enrichir les observations. */
export function buildMatchLookupMap(matches: Match[]): Map<string, Match> {
  const map = new Map<string, Match>();
  for (const match of matches) {
    const cle = (match.cle || '').trim();
    const id = String(match.idmatch_football || '').trim();
    if (cle) map.set(cle, match);
    if (id) map.set(id, match);
  }
  return map;
}

export function enrichObservationWithMatch(
  observation: Observation,
  match?: Match | null,
): Observation {
  if (!match) return observation;
  const competition =
    observation.matchCompetition?.trim() || match.competition?.trim() || undefined;
  const poule = observation.matchPoule?.trim() || match.poule?.trim() || undefined;
  if (
    competition === observation.matchCompetition &&
    poule === observation.matchPoule
  ) {
    return observation;
  }
  return { ...observation, matchCompetition: competition, matchPoule: poule };
}

export function enrichObservationWithMatchMap(
  observation: Observation,
  matchById: Map<string, Match>,
): Observation {
  const key = (observation.matchId || '').trim();
  if (!key) return observation;
  return enrichObservationWithMatch(observation, matchById.get(key));
}

export function enrichObservationsWithMatchMap(
  observations: Observation[],
  matchById: Map<string, Match>,
): Observation[] {
  return observations.map((obs) => enrichObservationWithMatchMap(obs, matchById));
}
